import { formatShortDate, periodNeedsYear } from '../../components/novarium/periodRange'
import { Variation } from '../ServicesStatistics/statisticsChange'
import { parseIsoDate } from '../ServicesStatistics/statisticsUtils'

/** Un porcentaje (en %) como fracción, que es lo que compara `pointsVariation`. */
export const toRatio = (percent: number | null): number | null => (percent === null ? null : percent / 100)

/** "1/8–31/8": el período anterior con que se compara; `null` si el backend no lo manda. */
export function previousPeriodRange(previousFrom: string | null | undefined, previousTo: string | null | undefined): string | null {
  if (!previousFrom || !previousTo) return null
  const from = parseIsoDate(previousFrom)
  const to = parseIsoDate(previousTo)
  const withYear = periodNeedsYear(from, to, new Date())
  return `${formatShortDate(from, withYear)}–${formatShortDate(to, withYear)}`
}

/**
 * Variación en la unidad del indicador (minutos u horas), para los que pueden valer cero o ser negativos y no admiten un
 * porcentaje: «5 min más que …». Sin los dos valores no hay con qué comparar; una diferencia que se escribe igual es «igual».
 * `format` escribe la diferencia ya redondeada.
 */
export function absoluteVariation(
  current: number | null,
  previous: number | null,
  format: (difference: number) => string,
): Variation | null {
  if (current === null || previous === null) return null
  const difference = Math.abs(current - previous)
  const text = format(difference)
  if (difference === 0 || format(0) === text) return { trend: 'same', value: '' }
  return { trend: current > previous ? 'up' : 'down', value: text }
}
